module.exports = __webpack_public_path__ + "static/media/unilever.31681e7e.png";